<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCommercialDashboardStore } from '@/stores/useCommercialDashboardStore'
import DashboardHeader from '@/v2/components/commercial-dashboard/DashboardHeader.vue'
import SyncStatusBanner from '@/v2/components/commercial-dashboard/SyncStatusBanner.vue'
import TeamOverviewTable from '@/v2/components/commercial-dashboard/TeamOverviewTable.vue'
import DashboardKpiCards from '@/v2/components/commercial-dashboard/DashboardKpiCards.vue'
import RenewalsCard from '@/v2/components/commercial-dashboard/RenewalsCard.vue'
import ClientsTable from '@/v2/components/commercial-dashboard/ClientsTable.vue'
import MyQuoteBillingSection from '@/v2/components/commercial-dashboard/MyQuoteBillingSection.vue'

const store = useCommercialDashboardStore()
const { loading, error, viewMode, currentData, teamData, dashboardTab } = storeToRefs(store)

onMounted(() => store.init())
</script>

<template>
  <div class="flex flex-col gap-4 p-4 sm:gap-8 sm:p-6 lg:gap-12 lg:p-8">
    <DashboardHeader />
    <SyncStatusBanner />

    <!-- ── Chargement / erreur ────────────────────────────────────────────── -->
    <div v-if="loading" class="flex justify-center py-12">
      <span class="loading loading-spinner loading-lg text-primary"></span>
    </div>

    <div v-else-if="error" class="alert alert-error">
      <span>{{ error }}</span>
    </div>

    <!-- ── Vue équipe ─────────────────────────────────────────────────────── -->
    <TeamOverviewTable v-else-if="viewMode === 'team' && teamData" />

    <!-- ── Vue individuelle (me ou member) ───────────────────────────────── -->
    <template v-else-if="currentData">
      <MyQuoteBillingSection v-if="dashboardTab === 'quote-billing'" />
      <template v-else>
        <DashboardKpiCards />
        <RenewalsCard />
        <ClientsTable />
      </template>
    </template>
  </div>
</template>
